// @ts-ignore
import cytoscape from 'cytoscape';
import contextMenus from 'cytoscape-context-menus';

// Plugins
import expandCollapseImport from 'cytoscape-expand-collapse';
import svgExportImport from 'cytoscape-svg';
import convertImport from 'color-convert';
import coseBilkentImport from 'cytoscape-cose-bilkent';
import cyColaImport from 'cytoscape-cola';
import cyDagreImport from 'cytoscape-dagre';
import cyKlayImport from 'cytoscape-klay';
import cyCiseImport from 'cytoscape-cise';
import cyFCoseImport from 'cytoscape-fcose';
import cyEulerImport from 'cytoscape-euler';
import edgehandlesImport from 'cytoscape-edgehandles';
import cxtmenuImport from 'cytoscape-cxtmenu';
// import compoundDragAndDrop from 'cytoscape-compound-drag-and-drop';
import cyCanvasImport from 'cytoscape-canvas';
import nodeHtmlImport from 'cytoscape-node-html-label';

import konva from 'konva';

// @ts-ignore
import htmlNodeLabel from '../../cytoscape-extensions/html-node-label.js';
// @ts-ignore
import edgeEditing from '../../cytoscape-extensions/edge-editing';
import registerMaporiumGrid from '../../cytoscape-extensions/grid-guide';

export function initCyPlugins() {
  // Use plugins (with `.default ??` fallback for non-ESM modules)
  const expandCollapse = (expandCollapseImport as any).default ?? expandCollapseImport;
  const svgExport = (svgExportImport as any).default ?? svgExportImport;
  const convert = (convertImport as any).default ?? convertImport;
  const coseBilkent = (coseBilkentImport as any).default ?? coseBilkentImport;
  const cyCola = (cyColaImport as any).default ?? cyColaImport;
  const cyDagre = (cyDagreImport as any).default ?? cyDagreImport;
  const cyKlay = (cyKlayImport as any).default ?? cyKlayImport;
  const cyCise = (cyCiseImport as any).default ?? cyCiseImport;
  const cyFCose = (cyFCoseImport as any).default ?? cyFCoseImport;
  const cyEuler = (cyEulerImport as any).default ?? cyEulerImport;
  const edgehandles = (edgehandlesImport as any).default ?? edgehandlesImport;
  const cxtmenu = (cxtmenuImport as any).default ?? cxtmenuImport;
  const cyCanvas = (cyCanvasImport as any).default ?? cyCanvasImport;
  const nodeHtml = (nodeHtmlImport as any).default ?? nodeHtmlImport;

  // Apply plugins to Cytoscape
  edgeEditing(cytoscape, konva);

  cytoscape.use(coseBilkent);
  cytoscape.use(cyDagre);
  cytoscape.use(cyKlay);
  cytoscape.use(cyCise);
  cytoscape.use(cyFCose);
  cytoscape.use(cyCola);
  cytoscape.use(cyEuler);
  cytoscape.use(edgehandles);
  cytoscape.use(cxtmenu);
  // cytoscape.use(compoundDragAndDrop);
 cyCanvas(cytoscape)
  cytoscape.use(contextMenus);
  cytoscape.use(expandCollapse);
  // cytoscape.use(undoRedo);
  cytoscape.use(nodeHtml);
  cytoscape.use(htmlNodeLabel);
  cytoscape.use(svgExport);
  registerMaporiumGrid(cytoscape);
}
